import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const [showIntro, setShowIntro] = useState(false);
  const [showVisa, setShowVisa] = useState(false);
  const [showConsularFee, setShowConsularFee] = useState(false);
  return (
    <div class="vertical-menu">
      <div data-simplebar class="h-100">
        {/* <!--- Sidemenu --> */}
        <div id="sidebar-menu">
          {/* <!-- Left Menu Start --> */}
          <ul class="metismenu list-unstyled" id="side-menu">
            {/* <li class="menu-title">Main</li> */}

            <li className={`${location.pathname === "/home" && "mm-active"}`}>
              <Link to="/home" class="waves-effect">
                <i class="ti-home"></i>
                {/* <span class="badge rounded-pill bg-primary float-end">2</span> */}
                <span>Dashboard</span>
              </Link>
            </li>

            <li
              className={`${
                (location.pathname === "/about-nepal" ||
                  location.pathname === "/about-romania" ||
                  location.pathname === "/honorary-consul") &&
                "mm-active"
              }`}
              onClick={() => setShowIntro(!showIntro)}
            >
              <a href="#!" class="has-arrow waves-effect" aria-expanded="false">
                <i class="ti-info-alt"></i>
                <span>Introduction</span>
              </a>
              {showIntro && (
                <ul class="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/about-romania">About Romonia</Link>
                  </li>
                  <li>
                    <Link to="/about-nepal">About Nepal</Link>
                  </li>
                  <li>
                    <Link to="/honorary-consul">Honorary Consul</Link>
                  </li>
                </ul>
              )}
            </li>

            {/* <li className={`${location.pathname === "/visa" && "mm-active"}`}>
              <Link to="/visa" class=" waves-effect">
                <i class="ion ion-md-airplane"></i>
                <span>Visa</span>
              </Link>
            </li> */}

            <li
              className={`${location.pathname === "/visa" && "mm-active"}`}
              onClick={() => setShowVisa(!showVisa)}
            >
              <a href="#!" class="has-arrow waves-effect" aria-expanded="false">
                <i class="ion ion-md-airplane"></i>
                <span>Visa/Consular Services</span>
              </a>
              {showVisa && (
                <ul class="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/visa?tag=program">
                      Program, Territorial Competence
                    </Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=entry">Entry and Stay in Romania</Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=notice">Visa Notice</Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=document">
                      Useful Document Template
                    </Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=protection">MFA Data Protection</Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=romanianVisa">Romanian Visa</Link>
                  </li>
                  <ul>
                    <li>
                      <Link to="/visa?tag=general">General Information</Link>
                    </li>
                    <li>
                      <Link to="/visa?tag=business">Business visa (C/A)</Link>
                    </li>
                    <li>
                      <Link to="/visa?tag=visit">Visit visa (C/VV)</Link>
                    </li>
                    <li>
                      <Link to="/visa?tag=tourism">Tourism visa (C/TU)</Link>
                    </li>
                    <li>
                      <Link to="/visa?tag=cultural">
                        Cultural, scientific and humanitarian activities visa
                        (C/ZA)
                      </Link>
                    </li>
                    <li>
                      <Link to="/visa?tag=employment">
                        Employment visa (D/AM)
                      </Link>
                    </li>
                    <li>
                      <Link to="/visa?tag=family">
                        Family reunification visa (D/VF)
                      </Link>
                    </li>
                    <li>
                      <Link to="/visa?tag=other">
                        Other purposes visa (D/AS)
                      </Link>
                    </li>
                    <li>
                      <Link to="/visa?tag=secondment">
                        Secondment visa (D/DT)
                      </Link>
                    </li>
                  </ul>
                </ul>
              )}
            </li>

            <li
              className={`${location.pathname === "/visa" && "mm-active"}`}
              onClick={() => setShowConsularFee(!showConsularFee)}
            >
              <a href="#!" class="has-arrow waves-effect" aria-expanded="false">
                <i class="ion ion-md-airplane"></i>
                <span>Consolur Fee</span>
              </a>
              {showConsularFee && (
                <ul class="sub-menu" aria-expanded="false">
                  <li>
                    <Link to="/visa?tag=I">I. Ask for a visa online</Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=II">
                      II. Latest Information of Interest
                    </Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=III">
                      III. Information of interest to British nationals
                    </Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=IV">
                      IV.Information of interest to British nationals and their
                      respective family members, who are covered by the
                      Withdrawal Agreement
                    </Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=V">V. General information</Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=VI">
                      VI. Conditions to enter Romania
                    </Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=VII">VII. Do I need a visa?</Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=VIII">VIII. Airport transit visa</Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=IX">IX. Transit visa</Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=X">X. Short-stay visa</Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=XI">XI. Long-stay visa</Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=XII">
                      XII. Diplomatic visa and service visa
                    </Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=XIII">
                      XIII. Specific Rules Relating to Visa Applicants who are
                      Family Members of EU, EEA or Swiss Citizens
                    </Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=XIV">
                      XIV. Who can apply for a Romanian visa
                    </Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=XV">XV. Visa processing fees</Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=XVI">XVI. Visa application forms</Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=XVII">
                      XVII. Regulations and agreements
                    </Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=XVIII">
                      XVIII. Frequently asked questions
                    </Link>
                  </li>
                  <li>
                    <Link to="/visa?tag=XIX">
                      XIX. Personal data processing in the field of visas and
                      local border traffic
                    </Link>
                  </li>
                </ul>
              )}
            </li>

            <li className={`${location.pathname === "/events" && "mm-active"}`}>
              <Link to="/events" class=" waves-effect">
                <i class="fas fa-calendar-alt"></i>
                <span>Events</span>
              </Link>
            </li>
            <li className={`${location.pathname === "/news" && "mm-active"}`}>
              <Link to="/news" class=" waves-effect">
                <i class="fas fa-newspaper"></i>
                <span>News</span>
              </Link>
            </li>
            <li
              className={`${location.pathname === "/gallery" && "mm-active"}`}
            >
              <Link to="/gallery" class=" waves-effect">
                <i class="fas fa-images"></i>
                <span>Gallery</span>
              </Link>
            </li>
            <li
              className={`${
                location.pathname === "/contact-us" && "mm-active"
              }`}
            >
              <Link to="/contact-us" class=" waves-effect">
                <i class="far fa-address-book"></i>
                <span>Contact Us</span>
              </Link>
            </li>
          </ul>
        </div>
        {/* <!-- Sidebar --> */}
      </div>
    </div>
  );
};

export default Sidebar;
